"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../Label"));

var _ToggleSwitch = _interopRequireDefault(require("./ToggleSwitch.style"));

var _dec, _class;

let ToggleSwitch = (_dec = (0, _reactJss.default)(_ToggleSwitch.default), _dec(_class = class ToggleSwitch extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    e.preventDefault();
    e.stopPropagation();
    const {
      id,
      value,
      visibility,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    const error = false;
    onChange({
      id,
      value: !value,
      error
    });
  } // render helper message


  renderHelperText(error, helperText, classes) {
    if (!helperText) return null;
    return _react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.helperText),
      value: helperText,
      error: error
    });
  }

  render() {
    const {
      classes,
      className,
      id,
      size,
      visibility,
      value,
      error,
      helperText
    } = this.props;
    return _react.default.createElement("div", {
      id: id
    }, _react.default.createElement("div", {
      className: (0, _clsx.default)(className, classes.switchWrap, classes[size], {
        active: !!value
      }, {
        disabled: visibility === 'disabled'
      }, {
        hidden: visibility === 'hidden'
      }, {
        error: !!error
      }),
      onClick: this.handleChange
    }, _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.switch, {
        active: !!value
      }, {
        error: !!error
      })
    })), this.renderHelperText(error, helperText, classes));
  }

}) || _class);
ToggleSwitch.defaultProps = {
  visibility: 'visible',
  error: false,
  value: false,
  size: 'medium',
  onChange: () => {}
};
var _default = ToggleSwitch;
exports.default = _default;